// src/components/About.js

import React from "react";

function About() {
  return (
    <section id="about">
      <h2>About Me</h2>
      <p>
        I am a passionate problem solver with a deep love for coding and technology.
      </p>
      <p>
        With a decade of experience, I have honed my skills in tech leadership, project
        management and software development. Today I lead a team of two junior engineers,
        mentoring them through code reviews, architecture decisions and delivery.
      </p>
      <h3>Areas I have worked in</h3>
      <ul className="skill-list areas-list">
        <li>Logistics</li>
        <li>Web3 & Crypto</li>
        <li>Medicine</li>
        <li>AI</li>
        <li>Agriculture</li>
      </ul>
    </section>
  );
}

export default About;
